import '../../../../../util/styles/index.js';
import { useOption } from '@react-aria/listbox';
import { mergeProps } from '@react-aria/utils';
import { useSelectionListBoxContext } from '../../../hooks/useSelectionListBoxContext.js';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

var useSelectionListItem = function useSelectionListItem(props, ref) {
  var state = props.state,
    item = props.item;
  var rendered = item.rendered,
    key = item.key;
  var _useSelectionListBoxC = useSelectionListBoxContext(),
    selectionMode = _useSelectionListBoxC.selectionMode;
  var _useReactAriaOption = useOption({
      key: key
    }, state, ref),
    optionProps = _useReactAriaOption.optionProps,
    isSelected = _useReactAriaOption.isSelected,
    isDisabled = _useReactAriaOption.isDisabled,
    isFocusVisible = _useReactAriaOption.isFocusVisible;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles,
    getInteractiveState = _useAdsStyles.getInteractiveState;
  var itemProps = {
    'data-focus': isFocusVisible ? 'true' : undefined
  };
  var listItemStyle = mapAdsStyles({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '4',
    py: '8',
    gap: '8',
    borderRadius: {
      value: '4'
    },
    minHeight: '40px',
    cursor: isDisabled ? 'not-allowed' : 'auto'
  });
  var interactiveStateStyles = isDisabled ? {} : getInteractiveState({
    type: 'filled'
  }).adsStyles;
  return {
    ref: ref,
    rendered: rendered,
    isSelected: isSelected,
    isDisabled: isDisabled,
    isFocusVisible: isFocusVisible,
    selectionMode: selectionMode,
    listItemProps: mergeProps(itemProps, optionProps, interactiveStateStyles, listItemStyle)
  };
};

export { useSelectionListItem };
//# sourceMappingURL=useSelectionListItem.js.map
